(function(){
  function wire(root){
    var track=root.querySelector('[data-lev32-track]');
    var arrows=root.querySelector('[data-lev32-arrows]');
    if(!track||!arrows)return;
    var prev=arrows.querySelector('[data-lev32-prev]');
    var next=arrows.querySelector('[data-lev32-next]');
    if(!prev||!next)return;
    function step(){var c=track.querySelector('.lev32-card');return c?c.getBoundingClientRect().width+20:track.clientWidth*0.8;}
    function sync(){
      var overflows = track.scrollWidth > track.clientWidth + 4;
      arrows.hidden = !overflows;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    if(window.ResizeObserver){new ResizeObserver(sync).observe(track);}
    sync();
  }
  function boot(){
    document.querySelectorAll('[data-lev32-rail-root]').forEach(function(r){
      if(r.dataset.lev32Wired)return;
      r.dataset.lev32Wired='1';
      wire(r);
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',boot);
})();
